
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./GasExportComp.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function GasExportComp() {

        useEffect(() => {
  
    trackPageVisit("GasExportComp");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorE, compressorF, CompressorTrendFaceplate } = useContext(CompressorContext);

const compressor = compressorE; // or E depending on page
    

    const [open, setOpen, ] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);






          const historianData = useMemo(() => {
            return {
              time: compressor.history?.time || [],
              PT_suction: compressor.history?.PT_suction || [],
              PT_discharge: compressor.history?.PT_discharge || [],
              TT_suction: compressor.history?.TT_suction || [],
              TT_discharge: compressor.history?.TT_discharge || [],
              FIC_suction: compressor.history?.FIC_suction || [],
              FIC_discharge: compressor.history?.FIC_discharge || [],
              speed: compressor.history?.speed || []
            };
          }, [compressor.history]);

    

    

  const DEFAULT_VALVES = {
  FCV_2501A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_2501: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_2502: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("GasExportComp_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2501A: { ...DEFAULT_VALVES.FCV_2501A, ...parsed.FCV_2501A },
      PCV_2501: { ...DEFAULT_VALVES.PCV_2501, ...parsed.PCV_2501 },
      PCV_2502: { ...DEFAULT_VALVES.PCV_2502, ...parsed.PCV_2502 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("GasExportComp_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [FIC_2305, setFIC_2305] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2305")) || 0;
            setFIC_2305(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2304, setTT_2304] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2304")) || 0;
            setTT_2304(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2303, setPT_2303] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2303")) || 0;
            setPT_2303(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  



  /* ================= VALVE STATUS ================= */

  const isXV2501Open = valves?.XV_2501 === false;
  const isXV2502Open = valves?.XV_2502 === false;
  const isXV2503Open = valves?.XV_2503 === false;
  const isXV2504Open = valves?.XV_2504 === false;
  const isXV2505Open = valves?.XV_2505 === false;
  const isXV2506Open = valves?.XV_2506 === false;


  const FIC_2510 = FIC_2305;
  const PT_2510 = PT_2303;
  const TT_2510 = TT_2304;
 

 
  const FIC_2502 = isXV2501Open ? FIC_2510 * 0.89 : 0;


const TT_2502 = isXV2501Open ? TT_2510 : 21;


const PT_2502 = isXV2501Open ? PT_2510 : 0.03;

  const FIC_2503 = FIC_2502 * (valveData?.PCV_2501?.opening || 0)/100;

  const FIC_25021 = FIC_2502 - FIC_2503;


// ================= MAIN INLET FLOW =================

const inletFlow = FIC_25021 || 0;

// ================= FLOW SPLIT =================

let FIC_2506 = 0;
let FIC_2507 = 0;

// BOTH OPEN → 50/50 SPLIT
if (isXV2503Open && isXV2504Open) {

  FIC_2506 = inletFlow * 0.5;
  FIC_2507 = inletFlow * 0.5;
}

// ONLY XV_2503 OPEN
else if (isXV2503Open) {

  FIC_2506 = inletFlow;
  FIC_2507 = 0;
}

// ONLY XV_2504 OPEN
else if (isXV2504Open) {

  FIC_2506 = 0;
  FIC_2507 = inletFlow;
}

// BOTH CLOSED
else {

  FIC_2506 = 0;
  FIC_2507 = 0;
}

const PIC_2501 = isXV2503Open ? PT_2502 * (valveData?.PCV_2502?.opening || 0)/100 : 0.03;
const PIC_2502 = isXV2504Open ? PT_2502 * (valveData?.PCV_2503?.opening || 0)/100 : 0.03;


const FIC_2505 = isXV2502Open ? 15.4 * (valveData?.FCV_2501A?.opening || 0)/100 : 0;

const FIC_2508 = FIC_2505*1.05;
const FIC_2509 = FIC_2505*1.053;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PIC_2501,
    suctionTemperature: TT_2502,
    suctionFlow: FIC_2506,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 3.1
  });


useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PIC_2501,
      suctionTemperature: TT_2502,
      suctionFlow: FIC_2506
    });

    forceRender(v => v + 1);

  }, 250); // DCS-like scan time

  return () => clearInterval(interval);

}, [PIC_2501, TT_2502, FIC_2506]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_2504a =
  compressorResults.dischargeFlow*1.22;

const PT_2504a =
  compressorResults.dischargePressure*28.6; 

const TT_2504a =
  compressorResults.dischargeTemperature;




const FIC_2504 = isXV2505Open ? FIC_2504a : 0;
const PT_2504 = isXV2505Open ? PT_2504a : 0;
const TT_2504 = isXV2505Open ? TT_2504a : 0;


  useEffect(() => {
  localStorage.setItem("PIC_2502", PIC_2502);
}, [PIC_2502]);

  useEffect(() => {
  localStorage.setItem("TT_2502", TT_2502);
}, [TT_2502]);

  useEffect(() => {
  localStorage.setItem("FIC_2507", FIC_2507);
}, [FIC_2507]);

  useEffect(() => {
  localStorage.setItem("FIC_2503", FIC_2503);
}, [FIC_2503]);




  useEffect(() => {
  localStorage.setItem("FIC_2504", FIC_2504);
}, [FIC_2504]);

  useEffect(() => {
  localStorage.setItem("PT_2504", PT_2504);
}, [PT_2504]);

  useEffect(() => {
  localStorage.setItem("TT_2504", TT_2504);
}, [TT_2504]);












  return (
    <div className="GasExportComp-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 250px"
      }}>
        GAS EXPORT COMPRESSORS STATION
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-2501"
        tag="XV_2501"
        x={165}
        y={238}
        isClosed={valves.XV_2501}
        toggle={toggleValve}
      />

      {/* XV-2502 */}
      <Valve
        className="XV-2502"
        tag="XV_2502"
        x={393}
        y={567}
        isClosed={valves.XV_2502}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2503 */}
      <Valve
        className="XV-2503"
        tag="XV_2503"
        x={675}
        y={650}
        isClosed={valves.XV_2503}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2504 */}
      <Valve
        className="XV-2504"
        tag="XV_2504"
        x={1041}
        y={650}
        isClosed={valves.XV_2504}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2505 */}
      <Valve
        className="XV-2505"
        tag="XV_2505"
        x={673}
        y={246}
        isClosed={valves.XV_2505}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-2506 */}
      <Valve
        className="XV-2506"
        tag="XV_2506"
        x={1037}
        y={246}
        isClosed={valves.XV_2506}
        toggle={toggleValve}
        r={270}

      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2501A */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="FCV-2501A"
          style={{ position: "absolute", left: 1084, top: 751}}  onClick={() => openPanel("FCV_2501A")}>
          
          <defs>
            <linearGradient id="metal_2501A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2501A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2501A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-2501A */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="PCV-2501A"
          style={{ position: "absolute", left: 435, top: 210, }}  onClick={() => openPanel("PCV_2501")}>
          
          <defs>
            <linearGradient id="metal_2501A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2501A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2501A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-2502 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="PCV-2502"
          style={{ position: "absolute", left: 644, top: 567, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_2502")}>
          
          <defs>
            <linearGradient id="metal_2502">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2502)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2502)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-2503 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="PCV-2503"
          style={{ position: "absolute", left: 1013, top: 567, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_25023")}>
          
          <defs>
            <linearGradient id="metal_2503">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2503)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2503)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          
          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 687,
                top: 410,
                width: 150,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PIC_2501,
                TT_2502,
                FIC_2506,
                FIC_2504a,
                PT_2504a,
                TT_2504a,
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}



           <div
            onClick={() =>
              alert(
                "This Compressor (C-104) will be developed fully and launched later in the Future."
              )
            }
            style={{
              position: "absolute",
              left: 1067,
              top: 410,
              width: 150,
              height: 30,

              background:
                compressor.status === "RUNNING"
                  ? "#00aa00"

                : compressor.status === "STARTING"
                  ? "#d4aa00"

                : compressor.status === "SHUTTING DOWN"
                  ? "#ff8800"

                : compressor.status === "READY"
                  ? "#0099ff"

                : compressor.status === "TRIPPED"
                  ? "#ff3300"

                : "#666666",

              color: "white",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              border: "2px solid cyan",

              cursor: "pointer",

              fontWeight: "bold",

              borderRadius: "8px",

              boxShadow:
                compressor.running
                  ? "0 0 15px lime"
                  : "0 0 10px red",

              transition: "0.3s"
            }}
          >
            {compressor.status}
          </div>




          




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2501A?.opening || 0)}
        x={1107}
        y={796}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2501?.opening || 0)}
        x={456}
        y={257}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2502?.opening || 0)}
        x={707}
        y={587}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2503?.opening || 0)}
        x={1086}
        y={587}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      
      
      <Transmitter
        tag="FIC-2510"
        value={[FIC_2510]}
        x={70}
        y={113}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF TEG CONTACTOR GAS COOLER TO INLET OF EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      <Transmitter
        tag="PT-2510"
        value={[PT_2510]}
        x={77}
        y={177}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF TEG CONTACTOR GAS COOLER TO INLET OF EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      <Transmitter
        tag="TT-2510"
        value={[TT_2510]}
        x={76}
        y={215}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={25}
        LL={10}
        c="lime"
        description="TEMPERATURE OF HYDRATED GAS AT THE DISCHARGE OF TEG CONTACTOR GAS COOLER TO INLET OF EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      
      <Transmitter
        tag="FIC-2502"
        value={[FIC_2502]}
        x={390}
        y={154}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      <Transmitter
        tag="PT-2502"
        value={[PT_2502]}
        x={313}
        y={152}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE OVERHEAD OF EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      <Transmitter
        tag="TT-2502"
        value={[TT_2502]}
        x={470}
        y={153}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={25}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE OVERHEAD OF EXPORT GAS COMPRESSOR K. O. DRUM"
      />

      <Transmitter
        tag="FIC-2503"
        value={[FIC_2503]}
        x={603}
        y={75}
        unit="SCF/S"
        max={200}
        HH={190}
        H={185}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF GAS AT THE OVERHEAD OF EXPORT GAS COMPRESSOR K. O. DRUM TO FLARE HEADER"
      />

      <Transmitter
        tag="FIC-2506"
        value={[FIC_2506]}
        x={714}
        y={642}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF HP COMPRESSOR C-105"
      />

      <Transmitter
        tag="FIC-2507"
        value={[FIC_2507]}
        x={1095}
        y={642}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF HP COMPRESSOR C-106"
      />

      <Transmitter
        tag="PIC-2501"
        value={[PIC_2501]}
        x={576}
        y={482}
        unit="MPa"
        max={1}
        HH={0.5}
        H={0.25}
        L={0.10}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF HP COMPRESSOR C-105"
      />

      <Transmitter
        tag="PIC-2502"
        value={[PIC_2502]}
        x={965}
        y={482}
        unit="MPa"
        max={1}
        HH={0.5}
        H={0.25}
        L={0.10}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF HP COMPRESSOR C-106"
      />

      <Transmitter
        tag="FIC-2505"
        value={[FIC_2505]}
        x={614}
        y={754}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM EXPORT GAS COMPRESSOR K. O. DRUM TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2508"
        value={[FIC_2508]}
        x={917}
        y={754}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM EXPORT GAS COMPRESSOR K. O. DRUM TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2509"
        value={[FIC_2509]}
        x={1201}
        y={754}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM EXPORT GAS COMPRESSOR K. O. DRUM TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2504"
        value={[FIC_2504]}
        x={1041}
        y={126}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF COMPRESSED GAS AT THE DISCHARGE OF C-105 AND C-106"
      />

      <Transmitter
        tag="PT-2504"
        value={[PT_2504]}
        x={863}
        y={126}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COMPRESSED GAS AT THE DISCHARGE OF C-105 AND C-106"
      />

      <Transmitter
        tag="TT-2504"
        value={[TT_2504]}
        x={970}
        y={126}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={25}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COMPRESSED GAS AT THE DISCHARGE OF C-105 AND C-106"
      />

      





      <LevelTransmitterIndicator
      tag="LT_2501"
      totalLevel={100000}
      inflows={[FIC_2510 * 0.018]}
      outflows={[FIC_2505]}
      responseFactor={0.05}
      columnX={256}
      columnY={254}
      columnWidth={86}
      columnHeight={177}
      textX={359}
      textY={325}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />




          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}

      
       

    </div>
  );
}


export default GasExportComp;